import React, { useState } from 'react';
import {  Offcanvas } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import './MobileNav.css'
const MobileNav = () => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div className="movile-icon">


      <Offcanvas show={show} onHide={handleClose} backdrop="static">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Wait Few Moments.....</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
         Developer sleeping .... ..
        </Offcanvas.Body>
      </Offcanvas>



<nav className="nav">
  <a href="#caragory" onClick={handleShow} className="nav__link">
  <i className="fa-solid fa-bars"></i>
    <span className="nav__text">Catagory</span>
  </a>




  
  <a href="#x" className="nav__link nav__link--active">
  <i className="fa-solid fa-heart"></i>
    <span className="nav__text">Love</span>
  </a>
  <a href="#xs" className="nav__link">
  <i className="fa-solid fa-house"></i>
    <span className="nav__text">Home</span>
  </a>
  <a href="#xe" className="nav__link">
  <i className="fa-solid fa-cart-shopping"></i>
    <span className="nav__text">Cart</span>
  </a>
  <a href="signup" className="nav__link">
  <i className="fa-solid fa-user"></i>
    <span className="nav__text">Profile</span>
  </a>
</nav>
        </div>
    );
};

export default MobileNav;